/* eslint-disable import/no-cycle */
import Request from '../utils/request';
import Native from '../utils/nativeProxy';

export default class WalletService {
  static getFundsInfo() {
    return Request.post({
      action: 'user.account.getFundsInfo',
    }, null, true).then((res) => res.data);
  }

  static wechatPreOrder({ amount, openId, type }) {
    return Native.getCityInfo().catch(() => ({})).then((data) => Request.post({
      action: 'user.deposit.h5WechatPreOrder',
      amount,
      cityCode: data.citycode,
      adCode: data.adcode,
      openId,
      type,
    }, null, true).then((res) => res.data));
  }

  static alipayPreOrder({ amount, type, returnUrl }) {
    return Native.getCityInfo().catch(() => ({})).then((data) => Request.post({
      action: 'user.deposit.wapAliPayPreOrder',
      amount,
      cityCode: data.citycode,
      adCode: data.adcode,
      returnUrl,
      type,
    }, null, true).then((res) => res.data));
  }

  static chargeDepositWechat({ amount, openId }) {
    return this.wechatPreOrder({ amount, openId, type: 0 });
  }

  static chargeWalletWechat({ amount, openId }) {
    return this.wechatPreOrder({ amount, openId, type: 1 });
  }

  static chargeDepositAlipay({ amount }) {
    return this.alipayPreOrder({ amount, type: 0 });
  }

  static chargeWalletAlipay({ amount }) {
    return this.alipayPreOrder({ amount, type: 1 });
  }

  static refund() {
    return Request.post({
      action: 'user.deposit.refund',
    }, null, true).then((res) => res.data);
  }

  static getDespoitDetail(start, limit) {
    return Request.post({
      action: 'user.deposit.detail',
      offset: start,
      limit,
    }, null, true).then((res) => res.data);
  }

  static manRefund({
    account, name, reasonDesc, type,
  }) {
    return Request.post({
      action: 'user.deposit.manRefund',
      account,
      name,
      reasonDesc,
      type,
    }, null, true);
  }

  static chargeActivity() {
    return Native.getCityInfo().catch(() => ({})).then((data) => Request.post({
      action: 'user.deposit.activity',
      cityCode: data.citycode,
      adCode: data.adcode,
    }, null, true).then((res) => res.data));
  }

  static certify({ cardId, name }) {
    return Request.post({
      action: 'user.certificate.sysCheck',
      cardId,
      name,
    }, null, true);
  }

  static getRedPacketInfo() {
    return Request.post({
      action: 'user.award.info',
    }, null, true).then((res) => res.data);
  }

  static withDraw({ account, accountName, amount }) {
    return Request.post({
      action: 'user.award.withdraw',
      account,
      accountName,
      amount,
    }, null, true).then((res) => res.data);
  }
}
